import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Функция для автоматического импорта всех JSON файлов из текущей папки
const loadResources = () => {
  const resources = {};

  // Ищем все файлы .json в подпапках (например, ./ua/generalInfo.json, ./en/generalInfo.json)
  const context = require.context('./', true, /\.json$/);

  context.keys().forEach((key) => {
    // key имеет вид: "./ua/generalInfo.json" или "./en/auth.json"
    const pathParts = key.split('/'); 
    const lng = pathParts[1]; // Получаем язык: "ua", "en"
    const filename = pathParts[2]; // Получаем имя файла
    const namespace = filename.replace('.json', ''); // Убираем расширение

    if (!resources[lng]) {
      resources[lng] = {};
    }

    // Загружаем содержимое файла и записываем в соответствующий namespace
    resources[lng][namespace] = context(key);
  });

  return resources;
};

const resources = loadResources();

// Автоматически собираем список всех пространств имен (имен файлов) для конфигурации
const allNamespaces = Object.keys(resources).length > 0 
  ? Object.keys(resources[Object.keys(resources)[0]]) 
  : [];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ua',
    
    // Если в t() не указан namespace, используем generalInfo (или первый попавшийся)
    defaultNS: allNamespaces.includes('generalInfo') ? 'generalInfo' : allNamespaces[0],
    ns: allNamespaces, 

    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;